import React, { useState } from 'react';
import Avatar from './Avatar';
import toast from 'react-hot-toast';

const AuthorCard = ({ author, article }) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;
    
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Lien copié dans le presse-papier !');
      
      setTimeout(() => setCopied(copied), 2000);
    } catch (error) {
      toast.error('Erreur lors de la copie du lien');
    }
  };

  return (
    <div className="bg-surface rounded-2xl p-6 border border-gray-700/30 shadow-lg">
      <div className="flex items-start justify-between gap-6">
        {/* Informations auteur */}
        <div className="flex items-start gap-4 flex-1">
          <Avatar 
            user={{ 
              username: author.username, 
              avatar: author.avatar 
            }} 
            size="lg"
          />
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-xl font-bold text-white">{author.username}</h3>
              {/* Tags de l'auteur */}
              {author.tags && author.tags.length > 0 && (
                <div className="flex gap-2 flex-wrap">
                  {author.tags.map(tag => (
                    <span
                      key={tag.id}
                      className="px-2 py-0.5 rounded-full text-xs font-medium text-gray-900"
                      style={{ backgroundColor: tag.color }}
                    >
                      {tag.name}
                    </span>
                  ))}
                </div>
              )}
            </div>
            
            {/* Bio */}
            {author.bio && (
              <p className="text-gray-400 text-sm leading-relaxed mb-3">
                {author.bio}
              </p>
            )}
            
            {/* Stats */}
            <div className="flex items-center gap-4 text-xs text-gray-500">
              <span>
                <i className="fas fa-newspaper mr-1"></i>
                {author.article_count || 0} articles publiés
              </span>
              {article && article.reading_time && (
                <span>
                  <i className="fas fa-clock mr-1"></i>
                  {article.reading_time} min de lecture
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Bouton partager */}
        <button
          onClick={handleShare}
          className="flex-shrink-0 bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-6 py-3 rounded-xl font-semibold transition-all hover:scale-105 shadow-lg flex items-center gap-2"
        >
          <i className={`fas fa-${copied ? 'check' : 'share-alt'}`}></i>
          <span>{copied ? 'Copié !' : 'Partager'}</span>
        </button>
      </div>
    </div>
  );
};

export default AuthorCard;
